export const steps = ['Data Privacy', 'Personal Info', 'Service Availed', 'Citizen Charter', 'Service Quality', 'Feedback'];

export const offices = [
  { label: 'Office of the Regional Director', value: 'Office of the Regional Director' },
  { label: 'Administrative Division', value: 'Administrative Division' },
  { label: 'Policy Planning and Research Division', value: 'Policy Planning and Research Division' },
  { label: 'Field Technical Assistance Division', value: 'Field Technical Assistance Division' },
  { label: 'Quality Assurance Division', value: 'Quality Assurance Division' },
  { label: 'Curriculum and Learning Management Division', value: 'Curriculum and Learning Management Division' },
  { label: 'Human Resource and Development Division', value: 'Human Resource and Development Division' },
  { label: 'Education Support Services Division', value: 'Education Support Services Division' },
  { label: 'Finance Division', value: 'Finance Division' }
];


export const subOffices = {
  'Office of the Regional Director': [
    { label: 'Office of the Regional Director', value: 'Office of the Regional Director' },
    { label: 'Office of the Assistant Regional Director', value: 'Office of the Assistant Regional Director' },
    { label: 'Information Communication and Technology Unit', value: 'Information Communication and Technology Unit' },
    { label: 'Legal Unit', value: 'Legal Unit' },
    { label: 'Public Affairs Unit', value: 'Public Affairs Unit' }
  ],
  'Administrative Division': [
    { label: 'Admin Proper', value: 'Admin Proper' },
    { label: 'Asset Management Section', value: 'Asset Management Section' },
    { label: 'Cash Section', value: 'Cash Section' },
    { label: 'General Services Unit', value: 'General Services Unit' },
    { label: 'Personnel Section', value: 'Personnel Section' },
    { label: 'Procurement Unit', value: 'Procurement Unit' },
    { label: 'Records Section', value: 'Records Section' },
    { label: 'Payroll Services Unit', value: 'Payroll Services Unit' }
  ],
  'Human Resource and Development Division': [
    { label: 'Human Resource and Development Division', value: 'Human Resource and Development Division' },
    { label: 'NEAP - National Educators\' Academy of the Philippines', value: 'NEAP - National Educators\' Academy of the Philippines' }
  ],
  'Curriculum and Learning Management Division': [
    { label: 'Curriculum and Learning Management Division', value: 'Curriculum and Learning Management Division' },
    { label: 'Learning Resources Management and Development System', value: 'Learning Resources Management and Development System' }
  ]
};
  
  export const services = {
   'Legal Unit': [
    { label: 'Legal Assistance to Walk-in Clients', value: 'Legal Assistance to Walk-in Clients' },
    { label: 'Request for Correction in School Record', value: 'Request for Correction in School Record' },
    { label: 'Request Certification for Non-Pending Administrative Case', value: 'Request Certification for Non-Pending Administrative Case' },
    { label: 'Others, please specify', value: 'lu_others' }
    ],
    'Personnel Section': [
      { label: 'Acceptance of Official Foreign Application', value: 'Acceptance of Official Foreign Application' },
      { label: 'Leave Application', value: 'Leave Application' },
      { label: 'Processing of Reclassification', value: 'Processing of Reclassification' },
      { label: 'Issuance of Official Foreign Travel', value: 'Issuance of Official Foreign Travel' },
      { label: 'Issuance of COE/Services Record', value: 'Issuance of COE/Services Record' },
      { label: 'Issuance of Personal Foreign Travel', value: 'Issuance of Personal Foreign Travel' },
      { label: 'Retirement/Survivorship Application', value: 'Retirement/Survivorship Application' },
      { label: 'Others, please specify', value: 'ps_others' }
    ],
    'Procurement Unit': [
    { label: 'Issuance of Bidding docs and RFQ', value: 'Issuance of Bidding docs and RFQ' },
    { label: 'Processing of PR', value: 'Processing of PR' },
    { label: 'Prepare procurement related report (i.e. APP, PMR, APCPI, EPA)', value: 'Prepare procurement related report (i.e. APP, PMR, APCPI, EPA)' },
    { label: 'Issuance of Notices, Contracts, or PO', value: 'Issuance of Notices, Contracts, or PO' },
    { label: 'TA Provision', value: 'TA Provision' },
    { label: 'Receiving of bidding docs and/or RFQ', value: 'Receiving of bidding docs and/or RFQ' },
    { label: 'Procurement process facilitation', value: 'Procurement process facilitation' },
    { label: 'Others, please specify', value: 'pu_others' }
    ],
    'Cash Section': [
      { label: 'Payment of Obligation', value: 'Payment of Obligation' },
      { label: 'Handling of Cash Advances', value: 'Handling of Cash Advances' },
      { label: 'Payment of External Claims', value: 'Payment of External Claims' },
      { label: 'Payment of Internal Claims', value: 'Payment of Internal Claims' },
      { label: 'Others, please specify', value: 'cs_others' }
    ],
    'Payroll Services Unit': [
      { label: 'Mentoring of PLIs', value: 'Mentoring of PLIs' },
      { label: 'Loan verification', value: 'Loan verification' },
      { label: 'Effecting of Step Increments', value: 'Effecting of Step Increments' },
      { label: 'Stoppage/Deletion of Deductions in the Payroll', value: 'Stoppage/Deletion of Deductions in the Payroll' },
      { label: 'Deletion/New deductions (Loans)', value: 'Deletion/New deductions (Loans)' },
      { label: 'Consolidation of payroll deduction', value: 'Consolidation of payroll deduction' },
      { label: 'Others, please specify', value: 'psu_others' }
    ],
    'Records Section': [
    { label: 'CAV Issuance', value: 'CAV Issuance' },
    { label: 'Issuance of Documents (Certified True Copy)', value: 'Issuance of Documents (Certified True Copy)' },
    { label: 'Receiving of Communication', value: 'Receiving of Communication' },
    { label: 'Issuance of Documents (Non-Certified True Copy)', value: 'Issuance of Documents (Non-Certified True Copy)' },
    { label: 'Receiving of Complaint', value: 'Receiving of Complaint' },
    { label: 'Releasing of Documents', value: 'Releasing of Documents' },
    { label: 'Others, please specify', value: 'rs_others' }
    ],
   'Asset Management Section': [
    { label: 'Performance Evaluation of External Bonds', value: 'Performance Evaluation of External Bonds' },
    { label: 'Procurement document processing for payment', value: 'Procurement document processing for payment' },
    { label: 'RFQ facilitation for External Providers', value: 'RFQ facilitation for External Providers' },
    { label: 'Issuance of COA required documents', value: 'Issuance of COA required documents' },
    { label: 'Issuance of Supplies to personnel', value: 'Issuance of Supplies to personnel' },
    { label: 'Issuance of transfer reports to SDOs and Schools', value: 'Issuance of transfer reports to SDOs and Schools' },
    { label: 'Others, please specify', value: 'ams_others' }
    ],
    'General Services Unit': [
      { label: 'Request for Use of Vehicle', value: 'Request for Use of Vehicle' },
      { label: 'Issuance of Certification of Non-Availability of Vehicle', value: 'Issuance of Certification of Non-Availability of Vehicle' },
      { label: 'Processing of Request for Repair or Replacement of material', value: 'Processing of Request for Repair or Replacement of material' },
      { label: 'Others, please specify', value: 'gsu_others' }
    ],
    'Policy Planning and Research Division': [
      { label: 'Creation of School ID', value: 'Creation of School ID' },
      { label: 'Request for Reversion - BEIS/NSBI', value: 'Request for Reversion - BEIS/NSBI' },
      { label: 'Data Request', value: 'Data Request' },
      { label: 'Add/Update SHS Program Offering', value: 'Add/Update SHS Program Offering' },
      { label: 'Request to Conduct Research Study', value: 'Request to Conduct Research Study' },
      { label: 'Updating Curricular Offering', value: 'Updating Curricular Offering' },
      { label: 'Technical Assistance in PMIS', value: 'Technical Assistance in PMIS' },
      { label: 'Others, please specify', value: 'pprd_others' }
    ],
    'Field Technical Assistance Division': [
      { label: 'RGADC XI Secretariat concerns', value: 'RGADC XI Secretariat concerns' },
      { label: 'BAC Alternative concerns', value: 'BAC Alternative concerns' },
      { label: 'Technical Assistance (TA) provision', value: 'Technical Assistance (TA) provision' },
      { label: 'Conduct of trainings', value: 'Conduct of trainings' },
      { label: 'School-Based Management (SBM) validation', value: 'School-Based Management (SBM) validation' },
      { label: 'Others, please specify', value: 'ftad_others' }
    ],
    'Quality Assurance Division': [
      { label: 'Grant of certificate of compliance', value: 'Grant of certificate of compliance' },
      { label: 'Application for TOSF', value: 'Application for TOSF' },
      { label: 'Quality Assurance of M&E Tools', value: 'Quality Assurance of M&E Tools' },
      { label: 'Application of Public Schools (Merging, etc.)', value: 'Application of Public Schools (Merging, etc.)' },
      { label: 'Issuance of Special Orders', value: 'Issuance of Special Orders' },
      { label: 'Application of Private Schools (SHS programs)', value: 'Application of Private Schools (SHS programs)' },
      { label: 'Government Assistance Subsidy', value: 'Government Assistance Subsidy' },
      { label: 'Others, please specify', value: 'qad_others' }
    ],
    'Human Resource and Development Division': [
      { label: 'Rewards and Recognition', value: 'Rewards and Recognition' },
      { label: 'Induction Program', value: 'Induction Program' },
      { label: 'Scholarship concerns', value: 'Scholarship concerns' },
      { label: 'Employee\'s welfare', value: 'Employee\'s welfare' },
      { label: 'Others, please specify', value: 'hrdd_others' }
    ],
   'NEAP - National Educators\' Academy of the Philippines': [
    { label: 'PD Programs/Learning & Development', value: 'PD Programs/Learning & Development' },
    { label: 'Issuance of Certificate of Un/Availability', value: 'Issuance of Certificate of Un/Availability' },
    { label: 'Room Accommodation/Function Hall', value: 'Room Accommodation/Function Hall' },
    { label: 'Accomplishment of RQA from other Government Agency\'s activities', value: 'Accomplishment of RQA from other Government Agency\'s activities' },
    { label: 'Others, please specify', value: 'neap_others' }
    ],
   'Finance Division': [
    { label: 'Certification as to Availability of Funds', value: 'Certification as to Availability of Funds' },
    { label: 'Downloading of SARO', value: 'Downloading of SARO' },
    { label: 'Processing of BURS', value: 'Processing of BURS' },
    { label: 'Letter of Acceptance for Downloaded Funds', value: 'Letter of Acceptance for Downloaded Funds' },
    { label: 'Disbursement Updating', value: 'Disbursement Updating' },
    { label: 'Endorsement of Request for Cash Allocation', value: 'Endorsement of Request for Cash Allocation' },
    { label: 'Obligation of Expenditure', value: 'Obligation of Expenditure' },
      { label: 'Others, please specify', value: 'fd_others' }
    ],
    'Office of the Regional Director': [
      { label: 'Others, please specify', value: 'ord_others' }
    ],
    'Office of the Assistant Regional Director': [
      { label: 'Others, please specify', value: 'oard_others' }
    ],
    'Information Communication and Technology Unit': [
    { label: 'Others, please specify', value: 'ictu_others' }
    ],
    'Public Affairs Unit': [
      { label: 'Others, please specify', value: 'pau_others' }
    ],
    'Admin Proper': [
      { label: 'Others, please specify', value: 'ad_others' }
    ],
    'Curriculum and Learning Management Division': [
    { label: 'Others, please specify',  value: 'clmd_others' }
    ],
    'Education Support Services Division': [
      { label: 'Others, please specify', value: 'essd_others' }
    ],
    'Learning Resources Management and Development System': [
      { label: 'Others, please specify', value: 'lrmds_others' }
    ]
  };

export const regions = [
  { label: 'Region I - Ilocos Region', value: 'Region I - Ilocos Region' },
  { label: 'Region II - Cagayan Valley', value: 'Region II - Cagayan Valley' },
  { label: 'Region III - Central Luzon', value: 'Region III - Central Luzon' },
  { label: 'Region IV-A - CALABARZON', value: 'Region IV-A - CALABARZON' },
  { label: 'Region IV-B - MIMAROPA', value: 'Region IV-B - MIMAROPA' },
  { label: 'Region V - Bicol Region', value: 'Region V - Bicol Region' },
  { label: 'Region VI - Western Visayas', value: 'Region VI - Western Visayas' },
  { label: 'Region VII - Central Visayas', value: 'Region VII - Central Visayas' },
  { label: 'Region VIII - Eastern Visayas', value: 'Region VIII - Eastern Visayas' },
  { label: 'Region IX - Zamboanga Peninsula', value: 'Region IX - Zamboanga Peninsula' },
  { label: 'Region X - Northern Mindanao', value: 'Region X - Northern Mindanao' },
  { label: 'Region XI - Davao Region', value: 'Region XI - Davao Region' },
  { label: 'Region XII - SOCCSKSARGEN', value: 'Region XII - SOCCSKSARGEN' },
  { label: 'Region XIII - Caraga', value: 'Region XIII - Caraga' },
  { label: 'NCR - National Capital Region', value: 'NCR - National Capital Region' },
  { label: 'CAR - Cordillera Administrative Region', value: 'CAR - Cordillera Administrative Region' },
  { label: 'BARMM - Bangsamoro Autonomous Region in Muslim Mindanao', value: 'BARMM - Bangsamoro Autonomous Region in Muslim Mindanao' }
];

export const age = [
  { label: '19 or Lower', value: '19 or Lower' },
  { label: '20-34', value: '20-34' },
  { label: '35-49', value: '35-49' },
  { label: '50-64', value: '50-64' },
  { label: '65 or Higher', value: '65 or Higher'}
]

export const serviceQualityQuestions = [
  {
    id: 'sqd0',
    label: 'SQD0: I had no difficulty locating this office in this building/compound.',
    description: 'Ease of finding the office'
  },
  {
    id: 'sqd1',
    label: 'SQD1: I easily found information about the requirements and steps in availing the service.',
    description: 'Accessibility of information'
  },
  {
    id: 'sqd2',
    label: 'SQD2: The requirements for this service are reasonable.',
    description: 'Reasonableness of requirements'
  },
  {
    id: 'sqd3',
    label: 'SQD3: The steps/procedures for this service are simple, clear and easy to follow.',
    description: 'Simplicity of procedures'
  },
  {
    id: 'sqd4',
    label: 'SQD4: The expected processing time for this service is acceptable.',
    description: 'Acceptability of processing time'
  },
  {
    id: 'sqd5',
    label: 'SQD5: The fees charged for this service are reasonable.',
    description: 'Reasonableness of fees'
  },
  {
    id: 'sqd6',
    label: 'SQD6: I am treated courteously by the staff.',
    description: 'Courtesy of staff'
  },
  {
    id: 'sqd7',
    label: 'SQD7: The staff are knowledgeable about the specific concern/transaction.',
    description: 'Staff competence'
  },
  {
    id: 'sqd8',
    label: 'SQD8: I got what I needed from this office.',
    description: 'Service outcome'
  },
  {
    id: 'sqd9',
    label: 'SQD9: Overall, I am satisfied with the service I received.',
    description: 'Overall satisfaction'
  },
  {
    id: 'sqd10',
    label: 'SQD10: This office has a clean and well-maintained facility that is conducive for government transaction.',
    description: 'Quality of facility'
  }
];

export const satisfactionOptions = [
  { value: 'Strongly Agree', gifSrc: '/images/very-happy.gif', color: 'white' },
  { value: 'Agree', gifSrc: '/images/happy.gif', color: 'white' },
  { value: 'Neutral', gifSrc: '/images/neutral.gif', color: 'white', requiresFeedback: true },
  { value: 'Disagree', gifSrc: '/images/sad.gif', color: 'white', requiresFeedback: true },
  { value: 'Strongly Disagree', gifSrc: '/images/angry.gif', color: 'white', requiresFeedback: true },
  { value: 'N/A', gifSrc: '/images/question.gif', color: 'white' }
];